import { render, staticRenderFns } from "./SingleBlog.vue?vue&type=template&id=0d1baffb&scoped=true"
import script from "./SingleBlog.vue?vue&type=script&lang=js"
export * from "./SingleBlog.vue?vue&type=script&lang=js"
import style0 from "./SingleBlog.scss?vue&type=style&index=0&id=0d1baffb&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1baffb",
  null
  
)

export default component.exports